var map = {
	"./2-ob1.png": "8518",
	"./2-ob2.png": "9f49",
	"./2-ob3.png": "34e9",
	"./l1-a.png": "8bd2",
	"./l1.png": "003f",
	"./l2-a.png": "e83a",
	"./l2.png": "fe3f",
	"./l3-a.png": "9290",
	"./l3.png": "c4ed",
	"./ob1.png": "6384",
	"./ob2.png": "a8ad",
	"./ob3.png": "93b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a966";